import React from "react";
import Tippy from "@tippyjs/react";
import { FaLock } from "react-icons/fa6";

export default function KrCell({ cell, table }) {
	const value = cell.getValue();
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;

	const ignoredColumn = hiddenColumns?.find((item) => item.id === columnId);

	if (!ignoredColumn?.value) {
		return <div className="ignore"></div>;
	}

	if (value?.locked) {
		return (
			<Tippy content={"Locked"} placement="bottom">
				<span>
					<FaLock color="#878EA6" />
				</span>
			</Tippy>
		);
	}

	return <>{value?.tot ?? "--"}</>;
}